<template>
  <div class="add-dealer pad">
    <div class="pad">
      <dealer-form @submitted="submitted" />
    </div>
  </div>
</template>

<script>
import DealerForm from '@/components/DealerForm.vue'
export default {
  name: 'AddDealer',
  components: {
    DealerForm
  },
  methods: {
    submitted () {
      setTimeout(() => this.$router.push('/dealers'), 300)
    }
  }
}
</script>

<style>

</style>
